import { getNsfwEnabled } from '../utils/userPrefs.js';

const LORA_INPUT_SELECTOR = [
  '#lora-id-input',
  '#lora-strength-input',
  '#sprite-lora-id-3',
  '#sprite-lora-strength-3',
  '[data-video-lora-rows] [data-video-lora-id]',
  '[data-video-lora-rows] [data-video-lora-strength]',
  '#free-image-lora-rows [data-free-lora-id]',
  '#free-image-lora-rows [data-free-lora-strength]',
].join(', ');

const LORA_BUTTON_SELECTOR = '#free-image-add-lora, [data-video-lora-add]';

const lockControl = (control) => {
  if (control.dataset.sfwLoraPrevDisabled == null) {
    control.dataset.sfwLoraPrevDisabled = control.disabled ? '1' : '0';
  }
  if ('value' in control && control.value) {
    control.value = '';
    control.dispatchEvent(new Event('input', { bubbles: true }));
  }
  control.disabled = true;
};

const unlockControl = (control) => {
  if (control.dataset.sfwLoraPrevDisabled == null) return;
  control.disabled = control.dataset.sfwLoraPrevDisabled === '1';
  delete control.dataset.sfwLoraPrevDisabled;
};

const syncSfwLoraLock = () => {
  const filtered = !getNsfwEnabled();
  document.querySelectorAll('.lora-filtered-notice').forEach((notice) => {
    notice.classList.toggle('hidden', !filtered);
    notice.hidden = !filtered;
    notice.closest('details')?.classList.toggle('is-sfw-lora-locked', filtered);
  });
  const controls = document.querySelectorAll(`${LORA_INPUT_SELECTOR}, ${LORA_BUTTON_SELECTOR}`);
  controls.forEach((control) => {
    if (!(control instanceof HTMLInputElement) && !(control instanceof HTMLButtonElement)) return;
    if (filtered) lockControl(control);
    else unlockControl(control);
  });
};

let started = false;

export const initSfwLoraLock = () => {
  if (started || typeof document === 'undefined') return;
  started = true;
  syncSfwLoraLock();
  document.addEventListener('nsfwPreferenceSelected', syncSfwLoraLock);
  document.querySelectorAll('[data-video-lora-rows], #free-image-lora-rows').forEach((rows) => {
    const observer = new MutationObserver(syncSfwLoraLock);
    observer.observe(rows, { childList: true });
  });
};
